// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tN_w","toggle":"styles_toggle__1JUQe","preview":"styles_preview__1b5Ua"};